// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f66f992a","453":"34804cd6","732":"91a1ad35"}[chunkId] + ".chunk.js";
};